export const DEFAULTS = {
  accept: 'image/png, image/svg+xml, image/jpeg, application/pdf',
  minSizeBytes: 1024,
  maxSizeBytes: 5242880,
  maxFiles: 1,
  multiple: false
};
